export default "/fonts/line-awesome.svg?f4b3204d4678bf15ec93569dea727e87";